import { styled, Button, ButtonCopy } from '@moleculeone/ui';
import { InputGroup } from '@blueprintjs/core';

import { CompoundEditorProps } from '@f/components/shared/compound-editor/CompoundEditor';

import { InsertCompound } from '../InsertCompound/InsertCompound';
import { CompoundEditorActions } from '../../hooks/useCompoundEditor';

const Container = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '50rem',
});

const ButtonContainer = styled('div', {
  display: 'flex',
  gap: '$4',
  alignItems: 'center',
});

interface ToolbarProps
  extends Pick<CompoundEditorProps, 'smiles' | 'name' | 'onNameChange' | 'setOpen' | 'isAnalogGenerationOpen'> {
  actions: Pick<CompoundEditorActions, 'onFragmentAtomMode' | 'onFragmentBondMode' | 'setMols' | 'redraw' | 'clear'>;
  context?: React.ReactNode;
}

export function Toolbar(props: ToolbarProps) {
  const { smiles, context, actions, name, onNameChange, isAnalogGenerationOpen } = props;
  const isEmptyEditor = !smiles;

  return (
    <>
      <Container>
        <InputGroup
          className="compound-editor-target-name-input"
          key={name}
          defaultValue={name}
          onBlur={event => {
            onNameChange(event.target.value);
          }}
          placeholder="Enter target name..."
        />

        {!isAnalogGenerationOpen && (
          <ButtonContainer>
            <InsertCompound onPickAtom={actions.onFragmentAtomMode} onPickBond={actions.onFragmentBondMode} />
            <Button
              weight="minimal"
              color="slate"
              text="Clean up"
              icon="auto_fix_normal"
              onClick={actions.redraw}
              size="small"
              disabled={isEmptyEditor}
            />
            <Button
              weight="minimal"
              color="slate"
              text="Reset"
              icon="delete"
              onClick={actions.clear}
              size="small"
              disabled={isEmptyEditor}
            />
            <ButtonCopy
              weight="minimal"
              color="slate"
              text="Copy SMILES"
              copy={smiles}
              disabled={isEmptyEditor}
              size="small"
            />
          </ButtonContainer>
        )}
      </Container>
      {context ? <div>{context}</div> : null}
    </>
  );
}
